import LocalizedMessage from '../common/LocalizedMessage';
/* eslint jsx-a11y/label-has-associated-control: ["error", {"assert": "either"}] */
import React, { useEffect, useRef, useState } from "react";
import SettingsService from "../../services/SettingsService";
import { useTranslation } from 'react-i18next';

export default function SupportReportingSetting() {
  const { t: tr } = useTranslation();
  const [enabled, setEnabled] = useState(true);
  const [loaded, setLoaded] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState("");
  const alive = useRef(true);
  useEffect(() => {
    SettingsService.getSettings()
      .then((settings) => {
        if (!alive.current) return;
        const setting = settings.find((item) => item.id === "supportReporting");
        setEnabled(!setting || setting.enabled !== false);
        setLoaded(true);
      })
      .catch((error) => {
        if (alive.current) setMessage(error.message);
      });
    return () => {
      alive.current = false;
    };
  }, []);
  const save = async () => {
    setBusy(true);
    setMessage("");
    try {
      await SettingsService.saveSetting({ id: "supportReporting", enabled });
      if (alive.current) {
        setMessage(tr("manage:integratedText25"));
        window.dispatchEvent(new Event("support-setting-changed"));
      }
    } catch (error) {
      if (alive.current) setMessage(error.message);
    } finally {
      if (alive.current) setBusy(false);
    }
  };
  return (
    <div className="card mb-3">
      <div className="card-body">
        <h5 className="card-title">{tr("manage:integratedText26")}</h5>
        <p>{tr("manage:integratedText27")}</p>
        <div className="form-group form-check">
          <input
            id="support-reporting-enabled"
            className="form-check-input"
            type="checkbox"
            checked={enabled}
            disabled={!loaded || busy}
            onChange={(event) => setEnabled(event.target.checked)}
          />
          <label
            className="form-check-label"
            htmlFor="support-reporting-enabled"
          >{tr("manage:integratedText28")}</label>
        </div>
        <button
          type="button"
          className="btn manage-button manage-red-button"
          disabled={!loaded || busy}
          onClick={save}
        >{tr("manage:integratedText29")}</button>
        {message && (
          <p role="status" className="mt-2">
            <LocalizedMessage value={message} />
          </p>
        )}
      </div>
    </div>
  );
}
